export const taxRegimeMock = [1, 2, 3];
